import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type {State} */
const initialState = false;

/**
 * @returns {State}
 */
const open = () => true;

/**
 * @returns {State}
 */
const close = () => false;

export default createReducer(initialState, {
  [types.FOLD_EXPENDED_SEARCH]: close,
  [types.UNFOLD_EXPENDED_SEARCH]: open,
});
